import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainContent from '../../../../generic-components/Layout/MainContent';
import {
  ACTUAL_FLOW_STEPS, STYLES, SUBMIT_TYPES, TEXTS,
} from '../consts/consts';
import LinedStepper from '../../../../generic-components/LinedStepper';
import Button from '../../../../generic-components/Button';
import { OnboardingContext } from '../InvoiceOnboarding';
import Icon from '../../../../generic-components/Icon';
import { accDetails, backBlackIcon, checkDetails } from '../../../../assets/svg';
import ToggleButton from './ToggleButton';
import { InvoicesContext } from '../../contexts/InvoicesContext';

const StepDetails = () => {
  const { t } = useTranslation();
  const invoiceContext = useContext(InvoicesContext);
  const flowContext = useContext(OnboardingContext);
  const {
    onStepSubmit, activeStep, isLoadingState,
  } = flowContext;

  const isEditMode = !!invoiceContext.initialObStep;

  const getInitialCheckState = () => {
    if (!isEditMode && JSON.stringify(flowContext?.invoiceCustomData?.enableCheckDepositPaymentMethod)) {
      return flowContext?.invoiceCustomData?.enableCheckDepositPaymentMethod;
    } if (JSON.stringify(invoiceContext?.settings?.enableCheckDepositPaymentMethod)) {
      return invoiceContext?.settings?.enableCheckDepositPaymentMethod;
    }
    return false;
  };

  const getInitialAchState = () => {
    if (!isEditMode && JSON.stringify(flowContext?.invoiceCustomData?.enableAchPaymentMethod)) {
      return flowContext?.invoiceCustomData?.enableAchPaymentMethod;
    } if (JSON.stringify(invoiceContext?.settings?.enableAchPaymentMethod)) {
      return invoiceContext?.settings?.enableAchPaymentMethod;
    }
    return false;
  };

  const [includeCheckDetails, setIncludeCheckDetails] = useState<boolean>(getInitialCheckState());
  const [includeAccDetails, setIncludeAccDetails] = useState<boolean>(getInitialAchState());
  const handleToggleIncludeCheckDetails = () => {
    onStepSubmit({ type: SUBMIT_TYPES.DETAILS.CHECK_DETAILS, data: !includeCheckDetails });
    setIncludeCheckDetails(!includeCheckDetails);
  };
  const handleToggleIncludeAccDetails = () => {
    onStepSubmit({ type: SUBMIT_TYPES.DETAILS.ACC_DETAILS, data: !includeAccDetails });
    setIncludeAccDetails(!includeAccDetails);
  };

  return (
    <MainContent
      className={STYLES.PAGES.COLOR.MAIN_CONTENT}
    >
      {!isEditMode && (
      <LinedStepper
        currentStep={activeStep}
        mainContainerCSS={STYLES.LINED_STEPPER.MAIN_CONTAINER}
        passStepAnimation={STYLES.LINED_STEPPER.STEP_ANIMATION}
        stepCSS={STYLES.LINED_STEPPER.STEP}
        stepContainerCSS={STYLES.LINED_STEPPER.STEP_CONTAINER}
        stepsAmount={ACTUAL_FLOW_STEPS}
      />
      )}
      <span className={STYLES.PAGES.DETAILS.TITLE}>{t(TEXTS.STEP_DETAILS.TITLE)}</span>
      <span className={STYLES.PAGES.DETAILS.TEXT}>{t(TEXTS.STEP_DETAILS.TEXT)}</span>
      <div className={STYLES.PAGES.DETAILS.CHECK_DETAILS_CONTAINER}>
        <Icon className={STYLES.PAGES.DETAILS.DETAILS_ICON} src={checkDetails} />
        <span className={STYLES.PAGES.DETAILS.DETAILS_TEXT}>{t(TEXTS.STEP_DETAILS.CHECK_DETAILS)}</span>
        <ToggleButton buttonId='toggleCheckDetails' toggleState={includeCheckDetails} toggle={handleToggleIncludeCheckDetails} />
      </div>
      <div className={STYLES.PAGES.DETAILS.ACC_DETAILS_CONTAINER}>
        <Icon className={STYLES.PAGES.DETAILS.DETAILS_ICON} src={accDetails} />
        <span className={STYLES.PAGES.DETAILS.DETAILS_TEXT}>{t(TEXTS.STEP_DETAILS.ACC_DETAILS)}</span>
        <ToggleButton buttonId='toggleAccDetails' toggleState={includeAccDetails} toggle={handleToggleIncludeAccDetails} />
      </div>
      <div className={`${STYLES.PAGES.DETAILS.NAV_BUTTONS_CONTAINER} ${isEditMode ? 'justify-center' : 'justify-between'}`}>
        {!isEditMode && (
        <Button
          onClick={() => onStepSubmit({ type: SUBMIT_TYPES.COLOR.NAVIGATE_BACK, data: '' })}
          childElement={<Icon className={STYLES.PAGES.DETAILS.CTA_BACK_ICON} src={backBlackIcon} />}
          title={t(TEXTS.STEP_COLOR.CTA_BACK)}
          className={STYLES.PAGES.DETAILS.CTA_BACK}
          id='elCtaBack'
          disable={isLoadingState}
        />
        )}
        <Button
          disable={isLoadingState}
          isLoading={isLoadingState}
          onClick={() => onStepSubmit({ type: '', data: '' })}
          title={invoiceContext.initialObStep ? t('ACTION_TYPE_UPDATE') : t(TEXTS.STEP_COLOR.CTA_NEXT)}
          className={STYLES.PAGES.DETAILS.CTA_CONTINUE}
          id='elCtaContinue'
        />
      </div>
    </MainContent>
  );
};

export default StepDetails;
